import { keyBy } from 'lodash';
export const Pet = {
    value: 'PET',
    name: 'Person Entity',
};
export const Organisation = {
    value: 'ORGANISATION',
    name: 'Organisation',
};
export const Program = {
    value: 'PROGRAM',
    name: 'Program',
};
const Basic = [Pet, Organisation];
const BasicByValue = keyBy(Basic, 'value');
export default {
    BasicByValue,
    Basic,
    Pet,
    Organisation,
    Program,
    isGroupByPet: value => value === Pet.value,
    isGroupByOrganisations: value => value === Organisation.value,
    isGroupByProgram: value => value === Program.value,
};
